import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RefineryStatus, RefineryStatusUtil } from 'src/app/domainObjects/refineryStatus';

@Component({
    selector: 'app-save-refinery-config-dialog',
    templateUrl: './save-refinery-config-dialog.component.html',
    styleUrls: ['./save-refinery-config-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SaveRefineryConfigDialogComponent implements OnInit {

  name: string;
  description: string;
  refineryStatus=[RefineryStatus.draft,RefineryStatus.design,RefineryStatus.building,RefineryStatus.designValidated,RefineryStatus.pipelinesVerified,RefineryStatus.refineryTested,RefineryStatus.production];//Object.keys(RefineryStatus);
  RefineryStatusUtil=RefineryStatusUtil;
  selectedStatus=RefineryStatus.draft;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    private dialogRef: MatDialogRef<SaveRefineryConfigDialogComponent>) { }

  ngOnInit(): void {
    this.name = this.data.configName ?? 'New Refinery Config';
    this.description = this.data.configDescription ?? '';
    this.selectedStatus = this.data.refineryStatus ?? RefineryStatus.draft;
  }

  save(): void {
    this.dialogRef.close({name: this.name,description:this.description,status:this.selectedStatus});
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
